export default {"src":"/_next/static/media/close-icon.d80aa7af.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};